import { svg } from "lit";
const icon = svg `<path d="M20 26.455L13.0257 19.4808L14.5171 17.983L18.953 22.4082V7.5H21.0469V22.4082L25.4828 17.983L26.9742 19.4808L20 26.455ZM7.5 32.4999V24.906H9.59396V30.406H30.406V24.906H32.4999V32.4999H7.5Z" fill="currentColor"/>`;
export default icon;
